
export const retrieveDeviceFlowInfo = () => {
  const item = window.localStorage.getItem('_od_df_usercode_') as string
  try {
    const dfInfo = JSON.parse(item) as {exp:string,usercode:string}
    return dfInfo.exp > new Date().toISOString() 
      ? { usercode: dfInfo.usercode }
      : undefined
  }
  catch {
    return undefined
  }
}

export const removeDeviceFlowInfo = () => {
  window.localStorage.removeItem('_od_df_usercode_')
}
